import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { AppLayout } from "../../../components/layout/Header";
import TextInput from "../../../components/forms/TextInput";
import SelectInput from "../../../components/forms/SelectInput";
import { createAgentResponse } from "../../../js/api/agentResponseApi";
import { listBuyersForSession } from "../../../js/api/buyersApi";
import { useAgentScope } from "../../../js/hooks/useAgentScope";
import { useDesk } from "../../../js/hooks/useDesk";
import { US_STATES } from "../../../js/utils/agentResponseOptions";

export default function AgentResponseNew() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const { session, writeAgentId, listAgentId, excludeAgentId } = useAgentScope();
  const desk = useDesk();
  const [buyers, setBuyers] = useState([]);
  const [form, setForm] = useState({
    buyerId: params.get("buyerId") || "",
    address: "",
    city: "",
    state: "",
    zip: "",
    mls: "",
    price: "",
    beds: "",
    baths: "",
    sqft: "",
  });

  useEffect(() => {
    listBuyersForSession(session, listAgentId, excludeAgentId).then(setBuyers);
  }, [session, listAgentId, excludeAgentId]);

  function update(event) {
    const { name, value } = event.target;
    setForm((current) => ({ ...current, [name]: value }));
  }

  async function handleSubmit(event) {
    event.preventDefault();
    if (!form.buyerId) {
      window.alert("Please choose the buyer this listing is for.");
      return;
    }
    const record = await createAgentResponse({
      buyerId: form.buyerId,
      agentId: writeAgentId,
      property: {
        address: form.address,
        city: form.city,
        state: form.state,
        zip: form.zip,
        mls: form.mls,
        price: form.price,
        beds: form.beds,
        baths: form.baths,
        sqft: form.sqft,
      },
    });
    navigate(desk.responsePath(record.id, "location"));
  }

  return (
    <AppLayout variant={desk.variant === "broker" ? "broker" : "agent"}>
      <div className="page-header">
        <div>
          <p className="eyebrow">Inquiry/Response</p>
          <h1>New Property Response</h1>
          <p className="page-lead">Tie this listing to a buyer, then walk Location & Lot through Agent Summary.</p>
        </div>
      </div>
      <form className="card" onSubmit={handleSubmit}>
        <SelectInput
          label="Buyer"
          name="buyerId"
          value={form.buyerId}
          onChange={update}
          required
          options={buyers.map((buyer) => ({ value: buyer.id, label: buyer.name || buyer.email }))}
        />
        <TextInput label="Street address" name="address" value={form.address} onChange={update} required />
        <div className="two-col">
          <TextInput label="City" name="city" value={form.city} onChange={update} />
          <SelectInput label="State" name="state" value={form.state} onChange={update} options={US_STATES} />
        </div>
        <div className="two-col">
          <TextInput label="ZIP" name="zip" value={form.zip} onChange={update} />
          <TextInput label="MLS #" name="mls" value={form.mls} onChange={update} />
        </div>
        <div className="two-col">
          <TextInput label="List price" name="price" value={form.price} onChange={update} placeholder="650000" />
          <TextInput label="Living area (sq ft)" name="sqft" value={form.sqft} onChange={update} />
        </div>
        <div className="two-col">
          <TextInput label="Beds" name="beds" value={form.beds} onChange={update} />
          <TextInput label="Baths" name="baths" value={form.baths} onChange={update} />
        </div>
        <div className="form-actions">
          <button type="button" className="secondary-btn" onClick={() => navigate(-1)}>
            Cancel
          </button>
          <button type="submit" className="pill-btn start-cta">
            Start response
          </button>
        </div>
      </form>
    </AppLayout>
  );
}
